<template>
<div >
   
  <b-modal v-if="!modalupd" id="modal-modifprod" hide-footer centered title="Modifier Categorie ">
    
 
  <form @submit="UpdateCategorie(model.id)">
    
    <div class="pl-lg-4">
      <div class="row">
       <div class="col-lg-12">
           <b-form-group
        id="input-group-1"
        label="Titre"
        label-for="input-1"
       >
          <b-form-input
             
            label="Titre"
            placeholder="titre categorie"
            input-classes="form-control-alternative"
            v-model="model.libelle"
            
            required
          />
           </b-form-group>
        </div>
        
         
        <div class="col-lg-6">
           
        </div>
       
      </div>
       
    </div>
    
   
    <hr class="my-4" />
    <!-- Description -->
   <center><b-btn type="submit" style="background-color:#c2b59b;color:#fff" >Modifier</b-btn></center> 
  </form>
   </b-modal>
</div>
</template>
<script>
import { setToken, put } from "@/mixins/api";
export default {
     name: 'ModalUpdateCategorie',
    data() {
      return {
         modalupd:false,
        model: {
          libelle: '',
          
          
        },
        userToken:
        localStorage.getItem("userToken") ||
        "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOjEsImlhdCI6MTU3OTczNDkxMSwiZXhwIjoxNjExMjcwOTExfQ.96_I_ZUs7ALBMY4pDsnjbT-fvvagVMsVlpi48eAKWGk"
          
      }
    },
    methods:{
        getCategorie(data)
        {
          console.log(data)
          this.model=data;
        },
         UpdateCategorie(id) {
              // e.preventDefault();
                  //let currentObj = this;
                put("category/"+id,this.model)
                 .then(resp => {
        this.output = resp.data.data; 
        this.$emit("Categoriesadd",this.data,this.modalupd=false);
        
        
         
      });
                
           this.modalupd = true;    
      
               // e.target.reset(); 
            }, 
      },
       mounted() {
    setToken(this.userToken);
    //this.loadData();
    
  },
}
</script>
                        